import { render } from "@testing-library/react";
import React from "react";
import $ from 'jquery';
import ProductService from '../services/product';
import SupplierService from '../services/supplier';
import OrderService from '../services/order';
import SelectedOrder from "../orders/selectedOrder";
import Utility from "../utilities/utility";
import Modal from 'react-bootstrap/Modal';
import Stock from '../services/stock';
import AuthorizationCheck from '../auth/authorizationCheck';

class AddStockOrderProduct extends React.Component {

    constructor() {
        super();

        const queryParams = new URLSearchParams(window.location.search);

        this.state = {
            products: [],
            suppliers: [],
            confirmationProductId: null,
            confirmationProductPrice: null,
            confirmAddProduct: false,
            currentUserRole: '',
            timeoutId: null
        };

        this.selectedOrder = localStorage.getItem('selectedOrder');

        this.accessLevel = queryParams.get('accessLevel');

        this.stockService = new Stock();
    }

    componentDidMount() {

        this.products();
        // this.fetchSuppliers();
    }

    products = async () => {

        let name = $('#name').val();
        let model = $('#model').val();
        let brand = $('#brand').val();
        let size = $('#size').val();

        try {
            const response = await this.stockService.productList(name, model, brand, size);

            this.setState({ products: await response.json() });


        } catch (error) {
            console.log(error)
        }



    }

    searchProduct = () => {

        let timer;

        clearTimeout(this.state.timeoutId);

        timer = setTimeout(() => {
            this.products();
        }, 1500);

        this.setState({ timeoutId: timer })
    }

    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }

    addToOrder = async (productId, price, confirmed = false) => {

        const orderId = localStorage.getItem('selectedOrder');

        let oldProductList = this.state.products;


        let quantity = $('#product-qty-' + productId).val();


        if (Utility.isEmpty(orderId) || Utility.isEmpty(quantity)) {

            $('#product-row-' + productId).before(
                '<div class="alert alert-danger order-product-alert">Erreur</div>'
            )

            $('.order-product-alert').delay(3000).fadeOut('slow');

            return;
        }

        try {

            const response = await OrderService.addToOrder(orderId, quantity, productId, price, confirmed)

            if (response.status == 409) {


                this.setState({

                    confirmationProductId: productId,
                    confirmationProductPrice : price,
                    confirmAddProduct: true
                });

                return;
            }
            if (response.ok) {

                const addResponse = await response.json();

                let products = oldProductList.filter((p) => {

                    if (p.id == productId) {

                        p.quantity = p.quantity - quantity;

                        return p;
                    }

                    return p;

                });




                this.setState({

                    products : products,

                    confirmAddProduct: false
                });

                $('#product-qty-' + productId).val('')

                $('#product-row-' + productId).before(

                    '<div class="alert alert-success order-product-alert">Produit Ajouté</div>'
                )

                $('.order-product-alert').delay(3000).fadeOut('slow');
            } else {

                $('#product-row-' + productId).before(

                    '<div class="alert alert-danger order-product-alert">Erreur</div>'
                )

                $('.order-product-alert').delay(3000).fadeOut('slow');
            }

        } catch (error) {

            console.log(error);

            $('#product-row-' + productId).before(

                '<div class="alert alert-danger order-product-alert">Erreur</div>'
            )

            $('.order-product-alert').delay(3000).fadeOut('slow');
        }




    }

    fetchSuppliers = async () => {

        const response = await SupplierService.supplierList();

        this.setState({

            suppliers: await response.json()
        })

    }



    hideProductConfirmationForm = () => {

        this.setState({

            confirmAddProduct: false
        });
    }

    readdProductToOrder = () => {

        this.addToOrder(this.state.confirmationProductId,this.state.confirmationProductPrice, true);
    }

    render() {

        const { products } = this.state;


        return (

            <div className=" container product-wrapper mt-3">
                <AuthorizationCheck accessLevel='MANAGER' userRole={this.setRole} />

                <h2 className="mb-3">Ajoute Cargo Produits</h2>



                <div className="messageHolder"></div>

                <Modal show={this.state.confirmAddProduct}>
                    <Modal.Header closeButton onHide={this.hideProductConfirmationForm}>Confirme Ajout du Produit</Modal.Header>
                    <Modal.Body>



                        <div className="form-wrapper mt-4">

                            <div className="messageHolder"></div>


                            <div className="form-group">
                                <p className="label text-center">Ce produit a été deja ajouté. Voulez vous ajouter ce produit encore?</p>
                                <button className='btn btn-danger full-width' onClick={this.readdProductToOrder}>Ajoute</button>
                            </div>


                        </div>



                    </Modal.Body>

                </Modal>


                <div className="form-wrapper">
                    <div className="row">
                        <div className="col">


                            <div className="form-group">
                                <input className="form-control" id="name" placeholder="Nom" onKeyUp={this.searchProduct} />
                            </div>
                        </div>
                        <div className="col">
                            <div className="form-group">
                                <input className="form-control" id="model" placeholder="Model" onKeyUp={this.searchProduct} />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">

                            <div className="form-group">
                                <input className="form-control" id="brand" placeholder="Marque" onKeyUp={this.searchProduct} />
                            </div>
                        </div>
                        <div className="col">
                            <div className="form-group">
                                <input className="form-control" id="size" placeholder="Numero" onKeyUp={this.searchProduct} />
                            </div>
                        </div>
                    </div>

                    


                </div>

                <SelectedOrder orderId={this.selectedOrder} orderService={OrderService} accessLevel={this.accessLevel} />

                <div className="card card-default mt-5 bg-primary text-white">

                    <div className="card-body">
                        <div className="row">
                            <div className="col">Description</div>
                            <div className="col">Prix</div>
                            <div className="col"></div>
                            <div className="col">Quantité</div>
                            <div className="col"></div>
                            <div className="col"></div>
                        </div>
                    </div>
                </div>

                {products && products.map(product =>

                    <div className="card card-default mt-2" key={product.id}>

                        <div className="card-body" id={"product-row-" + product.id}>
                            <div className="row">
                                <div className="col">{product.name} {product.model} {product.brand} {product.color} {product.size}</div>
                                <div className="col">{product.price}</div>
                                <div className="col">CPID: {product.supplierUniqueId}</div>
                                <div className="col" id={"epq-"+product.id}>{product.quantity}</div>
                                <div className="col">
                                    <div className="form-group">
                                        <input className="form-control" id={"product-qty-" + product.id} placeholder="Quantité Desirée" />
                                    </div>

                                </div>
                                <div className="col">
                                    <button className="btn btn-primary full-width-btn" onClick={() => this.addToOrder(product.id, product.price)}>Ajoute</button>

                                </div>
                            </div>
                        </div>
                    </div>

                )
                }





            </div>



        );
    }



}

export default AddStockOrderProduct;